import type { ReactNode } from 'react'
import { LumpsumRecommendationActionType } from '../../../api/common.types'
import { RecommendationFundTileHighlight } from './RecommendationFundTileHighlight'
import {
  RECOMMENDATION_FUNDS_SECTION_INSET_PX,
  RecommendationFundsSectionTitle
} from './RecommendationFundsSectionTitle'

type RecommendationFundSingleSectionProps = {
  title: string
  type: LumpsumRecommendationActionType
  sectionClassName?: string
  highlightIsin?: string
  fundId?: string
  children: ReactNode
}

export function RecommendationFundSingleSection({
  title,
  type,
  sectionClassName = '',
  highlightIsin = '',
  fundId = '',
  children
}: RecommendationFundSingleSectionProps) {
  const isHighlighted = highlightIsin.length > 0 && fundId.length > 0 && fundId === highlightIsin

  return (
    <div className={sectionClassName}>
      <RecommendationFundsSectionTitle title={title} type={type} />
      <div className="w-full pr-5" style={{ paddingInlineStart: RECOMMENDATION_FUNDS_SECTION_INSET_PX }}>
        <RecommendationFundTileHighlight isHighlighted={isHighlighted}>
          {children}
        </RecommendationFundTileHighlight>
      </div>
    </div>
  )
}
